// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"073437a9","455":"8eb228bc","488":"59017fb3","692":"e926cce2"}[chunkId] + ".chunk.js";
};